export default "__VITE_ASSET__15cfd44d__"